import React from 'react'
import { Box, Flex } from '@workwhile/ui'
import { Header } from 'components/Header'
import { useRuleDetailContextValue } from '../context/RuleDetailProvider'
import { RuleInfoCard } from './RuleInfoCard'
import { JurisdictionsSection } from './JurisdictionsSection'
import { RatesSection } from './RatesSection'
import { ExclusionsSection } from './ExclusionsSection'

const RuleDetailHeader = () => {
  const { state } = useRuleDetailContextValue()

  return <Header title={`Rule #${state.id}`} subTitle="Wage Rule" />
}

export const RuleDetailMain = () => {
  return (
    <>
      <RuleDetailHeader />
      <Box margin={3}>
        <Flex gap={3} wrap="wrap">
          <RuleInfoCard />
        </Flex>
        <Flex gap={3} wrap="wrap" marginTop={3}>
          <JurisdictionsSection />
          <ExclusionsSection />
        </Flex>
        <Flex gap={3} wrap="wrap" marginTop={3}>
          <RatesSection />
        </Flex>
      </Box>
    </>
  )
}
